document.addEventListener("DOMContentLoaded", function () {
  const variantInputs = document.querySelectorAll(".color-variant-input");
  const productImages = document.querySelectorAll(".product__media-item img");

  function formatValue(str) {
    return str.toLowerCase().replace(/'/g, "").replace(/\s+/g, "-");
  }

  function updateImages() {
    let selectedShirtColor = "";
    let selectedPrintColor = "";

    variantInputs.forEach((input) => {
      if (input.checked) {
        if (input.name === "Shirt Color") {
          selectedShirtColor = formatValue(input.value);
        } else if (input.name === "Print Color") {
          selectedPrintColor = formatValue(input.value);
        }
      }
    });

    productImages.forEach((image) => {
      const imageAlt = image.getAttribute("alt") || "";
      const parentElement = image.closest(".product__media-item");

      // Check if the image alt matches exactly the shirt color or the exact shirt-print combination
      const exactShirtMatch = imageAlt === selectedShirtColor;
      const exactComboMatch =
        imageAlt === `${selectedShirtColor}-${selectedPrintColor}`;

      if (exactShirtMatch || exactComboMatch) {
        parentElement.style.display = "block";
      } else {
        parentElement.style.display = "none";
      }
    });
  }

  variantInputs.forEach((input) => {
    input.addEventListener("change", updateImages);
  });

  // Initial call to set correct images on page load
  updateImages();
});
